<template>
  <div class="livestream">
    <div class="livestream-video">
      <video class="livestream-video__element" ref="element"/>
    </div>
    <div class="time-bar" ref="controlBar"
         :class="{'live': isLivestream}"
         :style="style"
         @mousemove="updateProgressHover"
         @mouseout="endProgressHover"
         @click="changeVideoPosition"
    >
      <div class="progress-hover" v-show="!isLivestream && progressHover"></div>
      <div class="progress"></div>
    </div>

    <div class="livestream-controls" v-show="player">

      <div class="livestream-button" @click="togglePause">
        <img v-if="paused" src="@/assets/conferencing-icons/play.svg"/>
        <img v-else src="@/assets/conferencing-icons/pause.svg"/>
      </div>

      <div class="livestream-controls__volume">
        <img
          :src="require(`@/assets/conferencing-icons/volume${volumeIcon}.svg`)"
          @click="player.muted(!muted)"
        />
        <input v-if="!isMobile" type="range" min="0" max="1" step="0.01" :value="volume" @input="player.volume($event.target.value)" />
      </div>

      <div class="livestream-controls__live" :class="{'live': isLivestream}" v-if="roomData.online && !isMobile">
        <img src="@/assets/global-icons/eye-show-small.svg"/>
        {{roomData.online}}

        <div v-if="isLivestream">LIVE</div>
      </div>
      <div class="livestream-controls__time" v-if="isDesktop">
        <span v-if="duration && !isLivestream">{{formatSecs(currentTime)}} / {{formatSecs(duration)}}</span>
      </div>

      <div style="margin-left: auto" class="livestream-button" @click="toggleFullscreen">
        <img v-if="fullscreen" src="@/assets/conferencing-icons/fullscreen-close.svg"/>
        <img v-else src="@/assets/conferencing-icons/fullscreen.svg"/>
      </div>

      <div class="livestream-button livestream-controls__leave" @click="handleLeaveRoom">LEAVE</div>

    </div>
  </div>
</template>

<script>
// todo: move to hls.js
import videojs from 'video.js';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Livestream',
  props: {
    roomData: Object
  },
  data: () => ({
    player: null,
    paused: false,
    muted: false,
    volume: 0,
    fullscreen: false,
    currentTime: 0,
    duration: 0,
    progressHover: 0,
    isLivestream: false
  }),
  computed: {
    ...mapGetters({
      isDesktop: 'viewport/isDesktop',
      isMobile: 'viewport/isMobile'
    }),
    volumeIcon(){
      if(this.muted) return 'mute';
      if(this.volume > 0.75) return '100';
      if(this.volume > 0.50) return '75';
      if(this.volume > 0.25) return '50';
      if(this.volume >= 0) return '25';
      else return ''
    },
    style(){
      if(this.isLivestream) return {}
			return {
				'--progress': `${(this.currentTime/this.duration)*100}%`,
        '--progress-hover': `${this.progressHover}%`
			};
		},
  },
  methods: {
    ...mapActions(['handleLeaveRoom']),
    toggleFullscreen(){
      if(!document.fullscreenElement) document.documentElement.requestFullscreen();
      else document.exitFullscreen();
    },
    togglePause(){
      if(this.paused) this.player.play();
      else this.player.pause();
    },
    formatSecs(secs) {
      return moment.utc(secs*1000).format('HH:mm:ss');
    },
    syncWithPlayer(e){
      this.paused = this.player.paused();
      this.volume = this.player.volume();
      this.muted = this.player.muted();
      this.fullscreen = Boolean(document.fullscreenElement);
      let d = this.player.duration()
      this.duration = d
      //use this instead of computed so updates correctly on join room + shows live marker
      if(d === Infinity) this.isLivestream = true
      else this.isLivestream = false

      if(e.type === 'timeupdate') {
        this.currentTime = this.player.currentTime()
      }
    },
    updateProgressHover(e) {
      let p = (e.offsetX/this.$refs.controlBar.clientWidth)*100
      this.progressHover = p
    },
    endProgressHover(e) {
      let off = 3
      let minY = this.$refs.controlBar.getBoundingClientRect().top + 10 //10px padding on time bar
      let maxY = minY + 5 //bar = 5px height
      if(e.clientY < (minY - off) || e.clientY > (maxY + off)) this.progressHover = 0
    },
    changeVideoPosition() {
      if(this.progressHover === 0) return
      let p = (this.progressHover/100) * this.duration
      this.player.currentTime(p)
    }
  },
  mounted(){
    // test links: //
    //short vid: 'https://vjs.zencdn.net/v/oceans.mp4'
    //vid: 'https://multiplatform-f.akamaihd.net/i/multi/will/bunny/big_buck_bunny_,640x360_400,640x360_700,640x360_1000,950x540_1500,.f4v.csmil/master.m3u8'
    //live: 'https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8'
    this.player = videojs(this.$refs.element, {
      sources: [this.roomData.joinLink],
      autoplay: true,
      controls: true
    });

    this.player.on(['play', 'pause', 'volumechange', 'timeupdate'], this.syncWithPlayer);
    document.addEventListener('fullscreenchange', this.syncWithPlayer);
  },
  beforeDestroy() {
    this.player?.dispose();
    document.removeEventListener('fullscreenchange', this.syncWithPlayer);
  }
};
</script>


<style lang="scss">
// sadly has to be unscoped to get this vjs styling to work
@import '~@/scss/components/conferencing/livestream.scss';
</style>
